import "./Hospitality.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EliteConciergeServices from "./sections/EliteConciergeServices";
import PlanYourExperience from "./sections/PlanYourExperience";
import FooterLegal from "@/reusable_sections/Footer";
export default function HospitalityPage() {
  return <div>
      <MainNavigation />
      <EliteConciergeServices />
      <PlanYourExperience />
      <FooterLegal />
    </div>;
}